"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleReactiveSearchProviderInstantSearch = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("../../components");
const ExampleReactiveSearchProviderInstantSearch = () => (react_1.default.createElement(components_1.ReactifySearchProvider, { mode: "instant-search", shopifyPermanentDomain: "usereactify-demo.myshopify.com" },
    react_1.default.createElement(react_1.default.Fragment, null)));
exports.ExampleReactiveSearchProviderInstantSearch = ExampleReactiveSearchProviderInstantSearch;
//# sourceMappingURL=ExampleReactiveSearchProviderInstantSearch.js.map